var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWoodIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 11.6255L18.5005 9.12597L16.0009 11.6255L18.5005 14.1263L21 11.6255ZM19.3336 8.29279L14.3333 3.29248L10.1674 7.45839L15.1677 12.4587L19.3336 8.29279ZM14.3333 11.6255L11.0006 8.29279L1 18.2934L4.33394 21.6261L14.3333 11.6255Z",
    stroke: "#607238",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2272 1.85241L13.5002 4.1266L11.0007 6.62614L9.1065 4.732C7.89449 3.51999 5.16717 4.1266 4.33398 4.95978L7.66793 1.62584C8.50111 0.792659 10.0919 0.717137 11.2284 1.85363L11.2272 1.85241Z",
    stroke: "#607238",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWoodIcon);
export default __webpack_public_path__ + "static/media/wood-icon.879f1525584c455422fe83236af29e5e.svg";
export { ForwardRef as ReactComponent };